const ITEMS = [
  "Handcrafted With Love",
  "Artisanal Indian Crafts",
  "Personalized Keepsakes",
  "Wedding & Corporate Hampers",
  "Custom Chocolate Ensembles",
  "Nationwide Express Delivery",
];

export default function Marquee() {
  return (
    <div className="relative bg-sand border-y border-gold/25 py-5 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track items-center">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex items-center shrink-0">
            {ITEMS.map((t, i) => (
              <span key={i} className="flex items-center shrink-0">
                <span className="font-display italic text-2xl md:text-3xl text-crimson/90 px-8 whitespace-nowrap">
                  {t}
                </span>
                <span className="h-2 w-2 rounded-full bg-gold shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
